<button type="button" class="glo-btn-close close-button" (click)="activeModal.dismiss('cancel')" aria-label="Close">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13">
    <use href="assets/sprite.view.svg#glo-close-2"></use>
  </svg>
</button>

<div class="content">
  <h2 class="title-2 mb-4">{{errorTitle}}</h2>
  <p>{{errorMessage}}</p>
  <button type="button" class="btn btn-action" (click)="cta()">{{errorCta}}</button>
</div>
